// Replaced by esbuild and jest
declare const REFLECT_VERSION: string;

export const version = REFLECT_VERSION;
